import { ContentCopy } from "./ContentCopy";
export default ContentCopy;